<template>
  <HoverVisible>
    <ContainerProduction v-bind="containerProps">
      <slot />
    </ContainerProduction>
  </HoverVisible>
</template>

<script>
import HoverVisible from "@bloglovin/inspire-engine/Components/HoverVisible.vue";
import ContainerProduction from "%/dynamic-component-editor/standard-elements/layouts/ContainerProduction.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";

export default {
  name: "HoverVisibleContainer",
  components: { HoverVisible, ContainerProduction },
  production: true,
  mixins: [DynamicElementMixin],
  inheritAttrs: false,
  computed: {
    containerProps() {
      return {
        ...this.$attrs,
        optionValues: this.optionValues,
        activeState: this.activeState,
        identifier: this.identifier,
        themeMode: this.themeMode,
        editMode: this.editMode,
      };
    },
  },
};
</script>
